import { render, staticRenderFns } from "./customerNotification.vue?vue&type=template&id=3def1839&scoped=true"
import script from "./customerNotification.vue?vue&type=script&lang=js"
export * from "./customerNotification.vue?vue&type=script&lang=js"
import style0 from "./customerNotification.vue?vue&type=style&index=0&id=3def1839&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3def1839",
  null
  
)

export default component.exports